import(/* webpackMode: "eager" */ "/app/apps/paz-corporate/app/[locale]/(charge)/pazcharge/not-found.tsx");
